import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LoadingButton } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { summaryDrawerSelector } from '../../selectors/summaryDrawer';
import { saveConfig } from '../../actions/designActions';
import { trackNavigationLinkTracking } from '../../utils/analytics/trackEvents';
import { ButtonSection } from './styles';
import { scheduleMeasureUrlSelector } from '../../selectors/scheduleMeasureUrl';

const FooterContent = ({ canContinue }) => {
  const dispatch = useDispatch();
  const [loadPirateCart, setLoadPirateCart] = useState(false);
  const { samUrl } = useSelector(scheduleMeasureUrlSelector);
  const { isOpen } = useSelector(summaryDrawerSelector);
  const inEditFlow = useSelector((state) => state.design.configurationSaved);

  const handleSaveConfiguration = () => {
    setLoadPirateCart(true);
    dispatch(saveConfig());
  };

  return (
    <ButtonSection>
      <LoadingButton
        variant="primary"
        disabled={!canContinue}
        loading={loadPirateCart}
        fullWidth
        onClick={() => handleSaveConfiguration()}
      >
        {inEditFlow ? 'Update My Carpet' : 'Save and Continue'}
      </LoadingButton>
      {isOpen && (
        <p>
          <a
            href={samUrl}
            rel="noreferrer"
            target="_blank"
            onClick={() => trackNavigationLinkTracking('project summary', 'Schedule a Measure Only')}
          >
            Schedule an in-home carpet measure
          </a>
          &nbsp;to get a quote for your project
        </p>
      )}
    </ButtonSection>
  );
};

FooterContent.propTypes = {
  canContinue: PropTypes.bool.isRequired,
};

export default FooterContent;
